import React from 'react'
import ReactDOM from 'react-dom'

import LoadStyles from '@driftt/tide-core/dist/styles'
import ConnectedApp from '@driftt/traffic-control'

import config from 'config' // FIXME: NO client ID
import { rootEpic, rootReducer } from 'modules'

import App from './layouts/App'

import '@driftt/react-dates/initialize'

import '@driftt/react-dates/lib/css/_datepicker.css'
import './index.css'

const sentryConfig = {
  dsn: config.SENTRY_KEY,
  release: '20261014120145-037859a',
}

ReactDOM.render(
  <ConnectedApp
    reducers={rootReducer}
    epics={rootEpic}
    render={() => <App />}
    authClientId={config.AUTH_CLIENT_ID}
    sentryConfig={sentryConfig}
    vNext
  />,
  document.getElementById('root')
)
LoadStyles()
